import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import getEnvEndpoints from "./endpoints";

const endpoints = getEnvEndpoints();

export const initializeInsight = () => {
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: endpoints.appInsightsKey,
    },
  });
  appInsights.loadAppInsights();
  return appInsights;
};

export const logEvent = (name, data) => {
  window.insight.trackEvent({ name, properties: data });
};

export const logPageView = (data) => {
  window.insight.trackPageView(data);
};
